/**
 * SolflareCampaignBadge Component
 *
 * Displays a small badge showing "2x Points" when the user:
 * - Has Solflare wallet connected
 * - Campaign is active
 * - Hasn't exceeded the bonus cap
 *
 * Styled to match the app's cyan theme.
 */

import { useSolflareCampaign } from '@/hooks/useSolflareCampaign';

export function SolflareCampaignBadge() {
  const { campaignData, isLoading } = useSolflareCampaign();

  // Only show badge if user is connected with Solflare wallet and hasn't reached the cap
  if (isLoading || !campaignData?.isActive || campaignData?.walletProvider !== 'Solflare' || campaignData?.remainingBonus <= 0) {
    return null;
  }

  return (
    <div className="inline-flex items-center">
      <img
        src="/solflare2x.svg"
        alt="Solflare 2x Points"
        className="h-6 w-auto"
      />
    </div>
  );
}
